import tour1 from './images/tour-1.jpeg'
import tour2 from './images/tour-2.jpeg'
import tour3 from './images/tour-3.jpeg'
import tour4 from './images/tour-4.jpeg'
import tour5 from './images/tour-5.jpeg'
import tour6 from './images/tour-6.jpeg'
// import img1 from './images/gallary-1.jpg'
// import img2 from './images/gallary-2.jpg'
// import img3 from './images/gallary-3.jpg'
// import img4 from './images/gallary-4.jpg'
// import img5 from './images/gallary-5.jpg'
// import img6 from './images/gallary-6.jpg'

export const pageLinks = [
  { id: 1, href: '#home', text: 'home' },
  { id: 2, href: '#about', text: 'about' },
  { id: 3, href: '#services', text: 'services' },
  { id: 4, href: '#tours', text: 'tours' },
]
export const socialLinks = [
  {
    id: 1,
    href: 'https://www.linkedin.com/',
    icon: 'fab fa-linkedin',
  },
  {
    id: 2,
    href: 'https://twitter.com/',
    icon: 'fab fa-twitter',
  },
  {
    id: 3,
    href: 'https://twitter.com/',
    icon: 'fab fa-facebook',
  },
  {
    id: 4,
    href: 'https://github.com/vishulearnere',
    icon: 'fab fa-squarespace',
  },
]

export const services = [
  {
    id: 1,
    icon: 'fas fa-wallet fa-fw',
    title: 'saving money',
    text: '𝑻𝒓𝒂𝒗𝒆𝒍 𝒔𝒎𝒂𝒓𝒕𝒆𝒓, 𝒏𝒐𝒕 𝒉𝒂𝒓𝒅𝒆𝒓 𝒘𝒊𝒕𝒉 𝒐𝒖𝒓 𝒄𝒐𝒔𝒕-𝒆𝒇𝒇𝒆𝒄𝒕𝒊𝒗𝒆 𝒕𝒓𝒂𝒗𝒆𝒍 𝒐𝒑𝒕𝒊𝒐𝒏𝒔.',
  },
  {
    id: 2,
    icon: 'fas fa-tree fa-fw',
    title: 'endless hiking',
    text: '𝑫𝒊𝒔𝒄𝒐𝒗𝒆𝒓 𝒉𝒊𝒅𝒅𝒆𝒏 𝒕𝒓𝒂𝒊𝒍𝒔 𝒂𝒏𝒅 𝒃𝒓𝒆𝒂𝒕𝒉𝒕𝒂𝒌𝒊𝒏𝒈 𝒍𝒂𝒏𝒅𝒔𝒄𝒂𝒑𝒆𝒔..',
  },
  {
    id: 3,
    icon: 'fas fa-socks fa-fw',
    title: 'amazing comfort',
    text: '𝑹𝒆𝒍𝒂𝒙, 𝒖𝒏𝒘𝒊𝒏𝒅, 𝒂𝒏𝒅 𝒍𝒆𝒕 𝒖𝒔 𝒕𝒂𝒌𝒆 𝒄𝒂𝒓𝒆 𝒐𝒇 𝒆𝒗𝒆𝒓𝒚𝒕𝒉𝒊𝒏𝒈 ',
  },
]
// place contact here too

export const tours = [
  {
    id: 1,
    image: tour1,
    title: 'Tibet Adventure',
    date: 'august 26th, 2023',
    place: 'china',
    duraction: '6 days',
    price: 'from ₹210000',
    info: 'Discover the mystical beauty of Tibet on our immersive adventure tour. Trek through breathtaking landscapes and ancient monasteries with expert guides.',
  },
  {
    id: 2,
    image: tour2,
    title: 'best of java',
    date: 'october 1th, 2023',
    place: 'indonesia',
    duraction: '11 days',
    price: 'from ₹140000',
    info: 'Experience the unique culture and natural beauty of Java on our expert-guided tour. Explore stunning temples and volcanic landscapes with us.',
  },
  {
    id: 3,
    image: tour3,
    title: 'explore hong kong',
    date: 'september 15th,, 2023',
    place: 'hong kong',
    duraction: '8 days',
    price: 'from ₹50000',
    info: "Immerse yourself in the vibrant culture and breathtaking scenery of Hong Kong on our expert-guided tour. Discover the city's hidden gems and must-see attractions.",
  },
  {
    id: 4,
    image: tour4,
    title: 'kenya highlights',
    date: 'december 5th,, 2023',
    place: 'kenya',
    duraction: '20 days',
    price: 'from ₹330000',
    info: "Embark on an unforgettable adventure through Kenya's natural wonders with our expert-guided tour. Experience stunning landscapes and unique wildlife up close.",
  },
  {
    id: 5,
    image: tour5,
    title: ' Discover Zambia ',
    date: 'august 26th, 2023',
    place: 'Zambia',
    duraction: '8 days',
    price: 'from ₹350000',
    info: 'Uncover the hidden treasures of Zambia on our expert-guided tour. From stunning wildlife to breathtaking landscapes, experience the beauty of this African gem.',
  },
  {
    id: 6,
    image: tour6,
    title: 'Incredible India',
    date: 'July 20th, 2023',
    place: 'India',
    duraction: '9 days',
    price: 'from ₹510000',
    info: 'Experience the magic of India on our expert-guided tour. From ancient temples to vibrant cities, explore the culture and diversity of this incredible country.',
  },
]

// export const gallery1 = [
//   {id:1, img:img1},
//   {id:2, img:img2},
//   {id:3, img:img3},
// ]
// export const gallery2=[
//   {id:4, img:img4},
//   {id:5, img:img5},
//   {id:6, img:img6},
// ]
